export var CompanyQueryKey;
(function (CompanyQueryKey) {
    CompanyQueryKey["Companies"] = "Companies";
})(CompanyQueryKey || (CompanyQueryKey = {}));
